var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({
    background: 'linear-gradient(to bottom, #424141, #ffff)',
  })},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }